import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormAutosuggest } from '@fs/zion-form'
import { FEMALE, useGenderTranslations, getNestedSubelementsByType, MALE, UNKNOWN, INTERSEX } from '@fs/zion-sls'

export default function FormStandardizedSexField({
  fieldName = '',
  addedSexCode = {},
  person = {},
  handleOnFocus = () => {},
  handleOnBlur = () => {},
  handleOnChange = () => {},
  autosuggestProps = {},
}) {
  if (!person?.id && !addedSexCode?.id) throw Error('FormStandardizedSexField requires a person or addedSexCode')
  const [t] = useTranslation()
  const genderTranslations = useGenderTranslations()
  const isAddingSex = Boolean(addedSexCode?.id)
  const sexField = addedSexCode?.id ? addedSexCode : getNestedSubelementsByType(person, 'SEX_CODE')?.[0]
  const isEditable = isAddingSex || (sexField?.typeData?.editable ?? true)
  const sexSuggestions = useMemo(
    () => [
      { key: UNKNOWN, primaryText: genderTranslations.unknown },
      { key: MALE, primaryText: genderTranslations.male },
      { key: FEMALE, primaryText: genderTranslations.female },
      { key: INTERSEX, primaryText: genderTranslations.intersex },
    ],
    [genderTranslations.female, genderTranslations.intersex, genderTranslations.male, genderTranslations.unknown]
  )

  const sexDisplayLabel = t('edit-essential-info.sex-code', 'Sex')
  const sexLabel = sexField?.displayLabel || sexDisplayLabel

  return (
    <FormAutosuggest
      name={fieldName}
      data-testid="sex-field"
      label={sexLabel}
      suggestions={sexSuggestions}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      disabled={!isEditable}
      warningValidate={(value) => {
        if (!value || !value?.key) return t('standardizedSexField.validation.warning', 'No Standard Selected')
        return null
      }}
      validMessage={t('standardizedSexField.validation.success', 'Standard Sex')}
      {...autosuggestProps}
    />
  )
}
